import * as React from 'react';

import { SVGProps } from './type';

const EyeClose = (props: SVGProps) => {
  const { color, width = 16, height = 17 } = props;
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.334 13.033A6.62 6.62 0 0 1 8 13.167c-4.205 0-6.245-3.789-6.607-4.539a.293.293 0 0 1 0-.257 9.38 9.38 0 0 1 1.274-1.924M2 2.5l12 12M4.667 4.741A6.471 6.471 0 0 1 8 3.833c4.205 0 6.245 3.789 6.607 4.539a.29.29 0 0 1 0 .257c-.235.485-1.17 2.241-2.94 3.42l-7-7.308Zm2 2.268A2 2 0 0 1 9.49 9.833L6.667 7.01Z"
        stroke={color}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeClose;
